/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { createGlobalStyle } from "styled-components";

export default createGlobalStyle`
  * {
    box-sizing: border-box;
  }

  html, body {
    width: 100%;
    height: 100%;
    margin: 0;
    padding: 0;
    overflow-x: hidden;
  }

  body {
    background-color: ${({ theme }) => theme.colors.GhostWhite};
  }

  .no-padding {
    padding-left: 0 !important;
    padding-right: 0 !important;
    width: 100%;
    margin: 0;
  }

  .container {
    position: relative;
    left: 32px;
  }

  .container.no-padding {
    left: 0;
  }

  @media (max-width: 1080px){
    .container {
      padding-left: 24px;
    }
  }

  @media (max-width: 576px){
    .container {
      left: 0px;
      padding-left: 12px;
    }
  }

  body, input, button {
    font: 1rem 'Open Sans', sans-serif;
  }

  a {
    text-decoration: none;
  }
  ul {
    list-style: none;
  }
  .show{
    display: initial;
  }
  .hide{
    display: none;
  }
  .linkKbbPriceAdvisor {
    position: absolute;
    width: 80%;
    margin: auto;
    left: 0;
    right: 0;
    top: 30%;
    bottom: 27%;
  }
`;
